const zh_hant = {
  change_pwd: "修改密碼",
  old_pwd: "當前密碼",
  new_pwd: "新密碼",
  repeat_pwd: "確認新密碼",
  confirm: "確認修改",
  required: "此項必填",
  account_cannot_contain_special_characters: "無法識別電郵地址",
  password_cannot_contain_special_characters_except: "密碼不能存在_和?以外的特殊字符",
  at_least_6: "字符長度需要不小於6",
  less_than_20: "字符長度需要小於20",
  less_than_50: "字符長度需要小於50",
  account_not_filled_in: "賬號未填寫",
  password_not_entered: "密碼未輸入",
  success: "已修改",
  password_error: "密碼不匹配",
  following_way: "您可以通過以下方式獲得我們的支持",
  mail: "信箱",
  phone_number: "電話"
};
const zh_cn = {
  change_pwd: "修改密码",
  old_pwd: "当前密码",
  new_pwd: "新密码",
  repeat_pwd: "确认新密码",
  confirm: "确认修改",
  required: "此项必填",
  account_cannot_contain_special_characters: "无法识别邮箱地址",
  password_cannot_contain_special_characters_except: "密码不能存在_和?以外的特殊字符",
  at_least_6: "字符长度需要不小于6",
  less_than_20: "字符长度需要小于20",
  less_than_50: "字符长度需要小于50",
  account_not_filled_in: "账号未填写",
  password_not_entered: "密码未输入",
  success: "已修改",
  password_error: "密码不匹配",
  following_way: "您可以通过以下方式获得我们的支持",
  mail: "信箱",
  phone_number: "电话"
};

const en = {
  change_pwd: "Change Password",
  old_pwd: "Current Password",
  less_than_20: "The character length must be less than 20",
  less_than_50: "The character length must be less than 50",
  new_pwd: "New Password",
  repeat_pwd: "Confirm New Password",
  confirm: "Confirm Change",
  password_error: "Passwords do not match",
  required: "This item is required",
  account_cannot_contain_special_characters: "Invalid email address",
  password_cannot_contain_special_characters_except:
    "Password cannot contain special characters except _ and ?",
  at_least_6: "Length must be at least 6",
  account_not_filled_in: "Account not filled in",
  password_not_entered: "Password not entered",
  success: "Successfully",
  following_way: "You can get our support through the following ways",
  mail: "Mail",
  phone_number: "Telephone"
};

const es = {
  change_pwd: "Cambiar contraseña",
  old_pwd: "Contraseña actual",
  new_pwd: "Nueva contraseña",
  repeat_pwd: "Confirmar nueva contraseña",
  confirm: "Confirmar cambio",
  required: "Este campo es obligatorio",
  account_cannot_contain_special_characters: "Dirección de correo electrónico no válida",
  password_cannot_contain_special_characters_except:
    "La contraseña no puede contener caracteres especiales excepto _ y ?",
  at_least_6: "La longitud debe ser al menos 6",
  less_than_20: "La longitud de los caracteres debe ser menor que 20",
  less_than_50: "La longitud de los caracteres debe ser menor que 50",
  account_not_filled_in: "Cuenta no ingresada",
  password_not_entered: "Contraseña no ingresada",
  success: "Cambio exitoso",
  password_error: "Las contraseñas no coinciden",
  following_way: "Puedes obtener nuestro soporte a través de las siguientes maneras",
  mail: "Correo electrónico",
  phone_number: "Teléfono"
};

export default { en, zh_hant, es, zh_cn };
